/**
 * Download a file from the COOL API with the login token attached.
 *
 * A plain <a href> or window.open() to a PHP download sends no Authorization
 * header, so the server cannot tell who is asking. Fetching it instead lets
 * installAuthTransport() sign the request; the response is then saved as a file.
 */

export function filenameFromDisposition(header, fallback) {
  const raw = String(header || '');
  const utf = raw.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf && utf[1]) {
    try {
      return decodeURIComponent(utf[1].trim());
    } catch {
      return utf[1].trim();
    }
  }
  const plain = raw.match(/filename="?([^";]+)"?/i);
  return (plain && plain[1] ? plain[1].trim() : '') || fallback;
}

/** Fetch `url` and save the response; throws with the server's message on failure. */
export async function downloadApiFile(url, { fallbackName = 'download', errorMessage = 'Could not download the file.' } = {}) {
  const res = await fetch(url);
  const type = String(res.headers.get('content-type') || '').toLowerCase();

  if (!res.ok || type.includes('application/json')) {
    let message = errorMessage;
    try {
      const data = await res.json();
      if (data?.message) message = data.message;
    } catch {
      /* keep default */
    }
    throw new Error(message);
  }

  const blob = await res.blob();
  const filename = filenameFromDisposition(res.headers.get('content-disposition'), fallbackName);
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
}
